import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  background-color: #222;
  height: 30px;
  padding: 20px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/components/Header/Header.style.js